<template>
  <div>
    <div class="column is-narrow add-btn" v-if="isAdmin && isRoot">
      <button
        class="button is-primary is-small"
        @click.prevent="showCreateForm"
      >
        <octicon :icon="plus" />&ensp;{{ $l("global.add", "Add") }}
      </button>
    </div>

    <data-table
      ref="table"
      :key="currentLocale"
      :items="taglistFunc"
      :per-page="20"
      :sort-desc="true"
      :theme="$_ui_theme_tables"
    >
      <data-column
        :sortable="false"
        field="serial"
        :label="$l('components.configurationUpdate.serial', 'No')"
        width="7%"
      />

      <data-column
        field="name"
        :label="$l('components.configurationUpdate.name', 'Name')"
      >
        <template #default="{ item }">
          <div class="truncate">
            {{ item.name }}
          </div>
        </template>
      </data-column>
      <data-column
        :sortable="false"
        field="description"
        :label="$l('components.configurationUpdate.description', 'Description')"
      >
        <template #default="{ item }">
          <div class="truncate">
            {{ item.description }}
          </div>
        </template>
      </data-column>

      <data-column
        field="status"
        :label="$l('components.configurationUpdate.status', 'Status')"
        :sortable="true"
      >
        <template #header>
          <div class="column-header">
            <span>{{
              $l("components.configurationUpdate.status", "Status")
            }}</span>
            <Dropdown
              placement="bottom-start"
              trigger="custom"
              :visible="filter.filterStatus.isFilterOpen"
              @on-clickoutside="
                handleCloseFilter(filter.filterStatus.filterType)
              "
            >
              <span
                href="javascript:void(0)"
                @click="toggleFilter('filterStatus')"
                class="icon"
              >
                <svg-icon
                  type="mdi"
                  :path="path"
                  :class="{
                    'filter-active': filter.filterStatus.isSubmitFilter,
                  }"
                ></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listStatus" :key="index">
                    <DropdownItem>
                      <input
                        type="checkbox"
                        v-model="filter.filterStatus.filterValues"
                        :value="i.value"
                      />

                      <span style="margin-left: 10px">{{
                        $l(`components.configurationUpdate.${i.name}`)
                      }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>

                  <div class="filter-button">
                    <Button
                      type="text"
                      size="small"
                      :disabled="!filter.filterStatus.filterValues.length"
                      @click="submitFilter(filter.filterStatus.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.submit", "Submit")
                      }}</span></Button
                    >
                    <Button
                      type="text"
                      size="small"
                      color="#2096f2"
                      @click="resetFilter(filter.filterStatus.filterType)"
                      ><span style="font-weight: bold">{{
                        $l("global.reset", "Reset")
                      }}</span></Button
                    >
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>

        <template #default="{ item }">
          <div
            class="status-column"
            :class="{
              'status-active': item.status,
              'status-inactive': !item.status,
            }"
          >
            {{
              item.status
                ? $l("components.configurationUpdate.active", "Activated")
                : $l("components.configurationUpdate.inactive", "Not activated")
            }}
          </div>
        </template>
      </data-column>

      <data-column :sortable="false">
        <template v-if="isAdmin" #default="{ item }">
          <div class="actions-column-tags">
            <span v-if="item.isDefault" class="tag">
              {{
                item.isDefault
                  ? $l("components.configurationUpdate.default", "Default")
                  : ""
              }}
            </span>
            <Dropdown trigger="click" placement="bottom-start">
              <span
                v-if="isRoot"
                href="javascript:void(0)"
                style="cursor: pointer"
              >
                <octicon :icon="kebabHorizontal" label="kebabHorizontal" />
              </span>
              <DropdownMenu slot="list">
                <DropdownItem @click.native="showUpdateForm(item)">
                  <span>{{
                    $l("components.configurationUpdate.update", "Update")
                  }}</span></DropdownItem
                >

                <div v-if="!item.isDefault" class="divider"></div>

                <DropdownItem
                  @click.native="changeStatus(item)"
                  v-if="!item.status"
                >
                  <span style="color: #2096f2">{{
                    $l("components.configurationUpdate.enable", "Enable")
                  }}</span>
                </DropdownItem>

                <DropdownItem
                  @click.native="showForm('deactive', item)"
                  v-if="item.status && !item.isDefault"
                >
                  <span style="color: red">{{
                    $l("components.configurationUpdate.disable", "Disable")
                  }}</span>
                </DropdownItem>

                <div v-if="item.status" class="divider"></div>

                <DropdownItem
                  @click.native="showForm('setDefault', item)"
                  :class="{ disabled: item.isDefault }"
                  v-if="item.status"
                >
                  <span style="color: green">
                    {{
                      $l(
                        "components.configurationUpdate.setDefault",
                        "Set Default"
                      )
                    }}</span
                  >
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>
    </data-table>

    <modal :show.sync="formModal.formCreateAndUpdate.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formCreateAndUpdate.isFormOpen = false"
        >
          <Icon size="25" type="ios-close" />
        </div>
        <div style="text-align: center; font-weight: bold">
          <span>{{
            formModal.formCreateAndUpdate.type === "create"
              ? $l("components.configurationUpdate.createTag", "Create product")
              : $l("components.configurationUpdate.updateTag", "Update product")
          }}</span>
        </div>

        <div style="margin: auto; width: 90%">
          <Form
            ref="form"
            :model="form"
            :rules="ruleValidate"
            label-position="top"
          >
            <FormItem ref="name" prop="name">
              <template slot="label">
                <strong>{{
                  $l("components.configurationUpdate.name", "Name")
                }}</strong>
              </template>

              <Input
                v-model="form.name"
                :placeholder="
                  $l('components.configurationUpdate.enterName', 'Enter name')
                "
              />
            </FormItem>

            <FormItem ref="description" prop="description">
              <template slot="label">
                <strong>{{
                  $l(
                    "components.configurationUpdate.description",
                    "Description"
                  )
                }}</strong>
              </template>

              <Input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                :placeholder="
                  $l(
                    'components.configurationUpdate.description',
                    'Description'
                  )
                "
              />
            </FormItem>

            <FormItem
              v-if="formModal.formCreateAndUpdate.type === 'update'"
              ref="status"
              prop="status"
            >
              <template slot="label">
                <strong>{{
                  $l("components.configurationUpdate.name", "Name")
                }}</strong>
              </template>
              <switches
                v-model="form.status"
                type-bold="false"
                theme="custom"
                color="blue"
                :class="{ disabled: form.isDefault }"
              ></switches>
              <span style="position: relative; top: -16px; left: 5px">{{
                $l("components.configurationUpdate.active", "Activated")
              }}</span>
            </FormItem>

            <FormItem>
              <div class="field is-grouped is-grouped-right">
                <div class="control">
                  <Button
                    style="margin-right: 8px"
                    @click="formModal.formCreateAndUpdate.isFormOpen = false"
                    >{{ $l("global.cancel", "Cancel") }}</Button
                  >
                </div>
                <div class="control">
                  <Button
                    v-if="formModal.formCreateAndUpdate.type === 'create'"
                    type="primary"
                    @click="handleClickCreate"
                  >
                    {{ $l("global.complete", "Compelete") }}</Button
                  >

                  <Button
                    v-if="formModal.formCreateAndUpdate.type === 'update'"
                    type="primary"
                    @click="handleClickUpdate"
                  >
                    {{ $l("global.complete", "Complete") }}</Button
                  >
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </box>
    </modal>

    <modal :show.sync="formModal.formConfirm.isFormOpen">
      <box>
        <div
          class="close-icon"
          @click="formModal.formConfirm.isFormOpen = false"
        >
          <Icon size="25" type="ios-close" />
        </div>
        <div class="repo-delete">
          <div class="columns is-multiline">
            <div
              class="column is-12"
              style="display: flex; justify-content: center"
            >
              <label class="label">{{
                formModal.formConfirm.type === "deactive"
                  ? $l(
                      "components.configurationUpdate.confirmDeactivate",
                      "Confirm deactivate"
                    )
                  : $l(
                      "components.configurationUpdate.confirmSetDefault",
                      "Confirm set as default"
                    )
              }}</label>
            </div>
            <div class="column is-12">
              <strong class="mr-3">{{
                $l("components.configurationUpdate.tagName", "Tag name") + ":"
              }}</strong>
              <span>{{ formModal.formConfirm.tagInfor.name }}</span>
            </div>
            <div class="column is-12">
              <label class="label">{{
                $l(
                  "components.configurationUpdate.tagWarning",
                  "Attention! This action may affect agent updates"
                )
              }}</label>
            </div>

            <div class="column is-12">
              <div slot="footer" class="field is-grouped is-grouped-right">
                <div class="control">
                  <button
                    class="button"
                    @click.prevent="formModal.formConfirm.isFormOpen = false"
                  >
                    {{ $l("global.close", "Close") }}
                  </button>
                </div>
                <div
                  class="control"
                  v-if="formModal.formConfirm.type === 'deactive'"
                >
                  <button
                    class="button is-danger"
                    @click.prevent="
                      changeStatus(formModal.formConfirm.tagInfor)
                    "
                  >
                    {{ $l("global.submit", "Submit") }}
                  </button>
                </div>

                <div
                  class="control"
                  v-if="formModal.formConfirm.type === 'setDefault'"
                >
                  <button
                    class="button is-danger"
                    @click.prevent="
                      setDefaultTag(formModal.formConfirm.tagInfor)
                    "
                  >
                    {{ $l("global.submit", "Submit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </box></modal
    >
  </div>
</template>

<script>
import UpdateApi from "@/api/Update";
import { plus, kebabHorizontal, cloudUpload } from "octicons-vue";
import { Tabs, Tab, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import vSelect from "vue-select";
import Switches from "vue-switches";

import { mapGetters } from "vuex";

import { mdiFilter } from "@mdi/js";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  Button,
  Form,
  FormItem,
  Input,
  Icon,
} from "iview";

export default {
  components: {
    Tabs,
    Tab,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    vSelect,
    Switches,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Button,
    Form,
    FormItem,
    Input,
    Icon,
  },

  data() {
    return {
      path: mdiFilter,
      cloudUpload,
      plus,
      kebabHorizontal,
      form: {},
      formModal: {
        formCreateAndUpdate: {
          isFormOpen: false,
          type: "",
        },
        formConfirm: {
          isFormOpen: false,
          type: "",
          tagInfor: {},
        },
      },
      filter: {
        filterStatus: {
          filterType: "status",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
      },
      listStatus: [
        {
          value: true,
          name: "active",
        },
        {
          value: false,
          name: "inactive",
        },
      ],

      isRoot: null,
    };
  },
  computed: {
    ...mapGetters(["authenticationClaims", "isAdmin", "currentLocale"]),

    defaultRule() {
      return {
        required: true,
        message: this.$l(
          "components.configurationUpdate.cannotBeLeftBlank",
          "Cannot be left blank"
        ),
        trigger: "blur",
      };
    },

    ruleValidate() {
      return {
        name: [
          this.defaultRule,
          {
            type: "string",
            validator: this.checkValidName,
            required: true,
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    // Check valid

    checkValidName(rule, value, callback) {
      if (value.length < 3 || value.length > 256) {
        callback(
          new Error(
            this.$l(
              "components.configurationUpdate.nameValidLength",
              "Name must have a length ranging from 3 to 256 characters"
            )
          )
        );
      } else {
        const regex = /^[a-zA-Z0-9_.-]+$/;
        if (!regex.test(value)) {
          callback(
            new Error(
              this.$l(
                "components.configurationUpdate.nameValidFormat",
                "Name cannot contain spaces and can only include alphanumeric characters, dots (.), or underscores (_)"
              )
            )
          );
        } else {
          callback();
        }
      }
    },

    // Filter

    toggleFilter(type) {
      event.stopPropagation();
      Object.keys(this.filter).forEach((key) => {
        if (key !== type) {
          this.filter[key].isFilterOpen = false;
        }
      });

      this.filter[type].isFilterOpen = !this.filter[type].isFilterOpen;
    },

    handleCloseFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        if (!this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.filterValues = [];
        }

        this.filter.filterStatus.isFilterOpen = false;
      }
    },

    submitFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        if (this.filter.filterStatus.filterValues.length === 0) {
          this.filter.filterStatus.isSubmitFilter = false;
        } else {
          this.filter.filterStatus.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }
    },

    resetFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        this.filter.filterStatus.filterValues = [];
        if (this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }
    },

    // Get tag table

    taglistFunc(filtering, sorting, paging) {
      const params = {
        status: this.filter.filterStatus.isSubmitFilter
          ? this.filter.filterStatus.filterValues.join(",")
          : "",
      };
      return UpdateApi.getTagVueTable(
        this.$http,
        filtering,
        sorting,
        paging,
        params
      ).then(function (res) {
        const dataLength = res.data.items.length;
        for (let i = 0; i < dataLength; i++) {
          res.data.items[i].serial = (paging.page - 1) * paging.perPage + i + 1;
        }
        return res.data;
      });
    },

    // Update tag - change status - set default

    updateTag() {
      UpdateApi.updateTag(this.$http, this.form).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
        this.formModal.formCreateAndUpdate.isFormOpen = false;
        this.formModal.formConfirm.isFormOpen = false;
      });
    },

    changeStatus(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        description: item.description,
        status: item.status ? false : true,
        isDefault: item.isDefault,
      };
      this.updateTag();
      this.form = {};
    },

    setDefaultTag(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        description: item.description,
        status: item.status,
        isDefault: true,
      };
      this.updateTag();
      this.form = {};
    },

    // Create tag

    showCreateForm() {
      this.formModal.formCreateAndUpdate.isFormOpen = true;
      this.formModal.formCreateAndUpdate.type = "create";
      this.form = {};
      this.$refs["form"].resetFields();
    },

    saveTag() {
      UpdateApi.addTag(this.$http, this.form).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
        this.formModal.formCreateAndUpdate.isFormOpen = false;
      });
    },

    // Update tag

    showUpdateForm(item) {
      this.formModal.formCreateAndUpdate.isFormOpen = true;
      this.formModal.formCreateAndUpdate.type = "update";
      this.form = {
        _id: item._id,
        name: item.name,
        description: item.description,
        status: item.status,
        isDefault: item.isDefault,
      };

      this.$refs["form"].resetFields();
    },

    // Show confim set default or deactive

    showForm(type, item) {
      if (type === "deactive") {
        this.formModal.formConfirm.type = type;
        this.formModal.formConfirm.isFormOpen = true;
        this.formModal.formConfirm.tagInfor = item;
      }

      if (type === "setDefault") {
        this.formModal.formConfirm.type = type;
        this.formModal.formConfirm.isFormOpen = true;
        this.formModal.formConfirm.tagInfor = item;
      }
    },

    // Handle Click

    handleClickCreate() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.saveTag();
        }
      });
    },

    handleClickUpdate() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.updateTag();
        }
      });
    },

    // Check is root
    async checkIsRoot() {
      await UpdateApi.checkIsRoot(this.$http).then((res) => {
        if (res.data && res.data.product === "root") {
          this.isRoot = true;
        }
      });
    },
  },

  mounted() {
    this.checkIsRoot();
  },
};
</script>

<style lang="scss" scoped>
@import "assets/app.scss";
.actions-column-tags {
  display: flex !important;
  justify-content: flex-end !important;

  .menu-button:hover {
    opacity: 0.5;
    cursor: pointer;
  }

  .tag {
    background-color: #208b24;
    color: #c6f2c7;
    font-weight: 900;

    @include responsive(large-desktop) {
      width: 100px;
      height: 20px;
      font-size: 16px;
      margin-right: 70px;
    }

    @include responsive(desktop) {
      width: 80px;
      height: 20px;
      font-size: 14px;
      margin-right: 50px;
    }

    @include responsive(tablet) {
      margin-right: 30px;
    }

    @include responsive(mobile) {
      margin-right: 30px;
    }
  }

  .menu-list {
    max-height: 200px;
    overflow: scroll;
  }
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}

.filter {
  z-index: 2;
  position: relative;
  cursor: pointer;
  font-weight: bold;
  left: 73.5%;
  top: 67px;
  width: 10px;

  .icon {
    .filter-active {
      color: #2096f2 !important;
    }
  }
}
</style>
